import { h } from 'preact';
import PropTypes from 'prop-types';

import SkeletonBlock from '../skeleton-block/skeleton-block';

const CtaSkeleton = ({ skeletonColor }) => <SkeletonBlock modifiers={['cta']} skeletonColor={skeletonColor} />;

CtaSkeleton.propTypes = {
  skeletonColor: PropTypes.string.isRequired,
};

export default CtaSkeleton;
